export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://business-training.by/razvitie-personala/kadrovyy-rezerv#service",
        "name": "Формирование и развитие кадрового резерва",
        "description": "Формирование и развитие кадрового резерва: оценка сотрудников, отбор кандидатов, индивидуальные планы развития, обучение, наставничество и подготовка будущих руководителей к новым ролям.",
        "provider": { "@id": "https://business-training.by/o-trenere#person" },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "кадровый резерв, формирование кадрового резерва, развитие кадрового резерва, подготовка будущих руководителей, оценка сотрудников, индивидуальный план развития, наставничество, обучение руководителей",
        "url": "https://business-training.by/razvitie-personala/kadrovyy-rezerv"
      },
      {
        "@type": "WebPage",
        "name": "Кадровый резерв: как подготовить сотрудников к будущим ролям",
        "description": "Кадровый резерв: оценка сотрудников, отбор, индивидуальные планы развития, обучение, наставничество и подготовка будущих руководителей.",
        "url": "https://business-training.by/razvitie-personala/kadrovyy-rezerv",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Person",
        "@id": "https://business-training.by/o-trenere#person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер, консультант, фасилитатор, сертифицированный коуч ICU",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое кадровый резерв?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Кадровый резерв — это система выявления и подготовки сотрудников, которые потенциально могут занять определённые должности или взять на себя дополнительные зоны ответственности. Это не просто список перспективных людей, а процесс, в котором сотрудник целенаправленно готовится к будущей роли."
            }
          },
          {
            "@type": "Question",
            "name": "Зачем компании нужен кадровый резерв?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Кадровый резерв помогает заранее готовить будущих руководителей, снижать зависимость от внешнего найма, сохранять экспертизу внутри компании, готовиться к росту и обеспечивать преемственность на ключевых позициях. Кроме того, он показывает сильным сотрудникам возможную траекторию развития."
            }
          },
          {
            "@type": "Question",
            "name": "Как формируется кадровый резерв?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Формирование кадрового резерва проходит несколько этапов: определение будущих потребностей, описание профиля должности, выдвижение кандидатов, оценка, формирование индивидуальных планов развития, само развитие через обучение и практику, наблюдение и обратная связь, повторная оценка и подготовка к назначению."
            }
          },
          {
            "@type": "Question",
            "name": "Кого включают в кадровый резерв?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Критерии зависят от будущей роли. При отборе учитывают результаты работы, профессиональные компетенции, управленческий потенциал, способность учиться, самостоятельность, ответственность, коммуникацию, готовность брать дополнительную ответственность и мотивацию к развитию. Высокий результат не означает автоматическую готовность к повышению."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценить кандидатов в кадровый резерв?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Оценка определяет текущий уровень компетенций, потенциал и зоны развития. Используются результаты оценки компетенций, интервью, обратная связь, наблюдение и рабочие показатели. Для будущих руководителей отдельно оцениваются управленческие компетенции, потому что лучший специалист не всегда становится лучшим руководителем."
            }
          },
          {
            "@type": "Question",
            "name": "Чем кадровый резерв отличается от списка сотрудников на повышение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Список на повышение лишь фиксирует кандидатов, а кадровый резерв предполагает системную подготовку. Резервист получает индивидуальный план развития, практику, наставничество и обратную связь. Сам факт включения в резерв ничего не развивает — важна именно работа по подготовке к будущей роли."
            }
          },
          {
            "@type": "Question",
            "name": "Как развивать сотрудников кадрового резерва?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Развитие резервиста не ограничивается обучением. Используются разные инструменты: обучение, практика, наставничество, развивающие задачи, проектная работа, временная замена руководителя, регулярная обратная связь и коучинг. Инструмент подбирается под конкретный дефицит компетенций."
            }
          },
          {
            "@type": "Question",
            "name": "Как связан кадровый резерв с ИПР?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Кадровый резерв отвечает на вопрос, кого компания готовит к будущей роли, а индивидуальный план развития — что конкретно этому сотруднику нужно развить. Для каждого резервиста формируется ИПР, который описывает компетенции, действия, инструменты, сроки и критерии результата."
            }
          },
          {
            "@type": "Question",
            "name": "Нужно ли обучать сотрудников кадрового резерва?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение — один из инструментов, но не единственный. Для одной компетенции нужен тренинг, для другой — практика, для третьей — наставничество, для четвёртой — работа над реальным проектом. Если у многих резервистов общий дефицит, обучение можно организовать в виде корпоративной программы."
            }
          },
          {
            "@type": "Question",
            "name": "Как подготовить сотрудника к должности руководителя?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Переход от специалиста к руководителю требует развития новых компетенций: лидерство, постановка задач, делегирование, контроль, обратная связь, мотивация, управление конфликтами, принятие решений, коммуникация и управление изменениями. Эти навыки развиваются через обучение и обязательную практику в реальных рабочих ситуациях."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценить готовность резервиста к новой должности?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Готовность оценивается через сравнение текущего уровня компетенций с требованиями будущей роли. Определяется разрыв, составляется план развития, сотрудник получает практику, затем проводится повторная оценка. На её основе делается вывод, готов ли человек к назначению или требует дальнейшего развития."
            }
          },
          {
            "@type": "Question",
            "name": "Кто должен отвечать за кадровый резерв — HR или руководитель?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Это совместная ответственность. HR/L&D организует систему, инструменты и контроль, а руководитель помогает определить приоритеты, даёт обратную связь и создаёт возможности для практики. Если резерв существует только в HR-системе и не используется руководителем, он быстро становится формальным."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли создать кадровый резерв для небольшой компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, для небольшой компании кадровый резерв может быть компактным: несколько ключевых ролей и несколько сотрудников, которых готовят к ним. Важна не масштабность системы, а её практичность: понятные будущие роли, оценка, планы развития и регулярная обратная связь."
            }
          },
          {
            "@type": "Question",
            "name": "Как избежать формального отношения к кадровому резерву?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Формальность появляется, когда создают список резервистов и ничего не делают дальше. Чтобы этого избежать, нужно определять конкретную будущую должность, формировать индивидуальные планы развития, давать практику, подключать руководителя и наставника и проводить повторную оценку результата."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}